import React, { PropTypes } from 'react'
import i18n from '../../../lib/i18n'
import cn from 'classnames'
import styles from './ColorSelectWrapper.scss'
import get from 'lodash/get'
import last from 'lodash/last'
import { components as reactSelectComponents } from 'react-select'
import { ReactSelect } from './SelectWrap'

const i18claimsZoom = i18n('claimsZoom')

function noOptionsMessage({ inputValue }) { // eslint-disable-line no-unused-vars
	return i18claimsZoom('noResultsText')
}

const ColorValue = ({ innerProps, data, selectProps, isDisabled, clearValue }) => {
	const showLabel = selectProps.className.includes('todo-color-select')

	function handleMouseDown(event) {
		if (!isDisabled) {
			clearValue()
		}
		event.stopPropagation() // for sanity's sake
	}

	return (
		<div {...innerProps} className={showLabel ? styles.colorValueTodo : styles.colorValue} title={data.label}>
			{data.colorCode && <div className="color-sqr-value" style={{background: data.colorCode }} onMouseDown={handleMouseDown}></div>}
			{showLabel && <span>{data.label}</span>}
		</div>
	)
}
ColorValue.propTypes = {
	isDisabled: PropTypes.bool,
	data: PropTypes.object, // Option
	clearValue: PropTypes.func,
    innerProps: PropTypes.object,
	selectProps: PropTypes.object,
}

const ColorOption = ({ innerRef, innerProps, data, selectOption, children }) => {
	function handleMouseDown(event) {
		event.preventDefault()
		event.stopPropagation()
		selectOption(data)
	}

	return (
		<div
			ref={innerRef}
			{...innerProps}
			onMouseDown={handleMouseDown}
			className={styles.colorOption}
		>
			{data.colorCode != null &&
				<div style={{background: data.colorCode, width: '15px', height: '15px', marginRight: '5px'}}></div>
			}
			<span style={{ verticalAlign: 'middle', display: 'inline' }}>{children}</span>
		</div>
	)
}
ColorOption.propTypes = {
	data: PropTypes.object, // Option
	selectOption: PropTypes.func,
	children: PropTypes.node,
    innerRef: PropTypes.oneOfType([
        // Either a function
        PropTypes.func,
        // Or the instance of a DOM native element (see the note about SSR)
        PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
    innerProps: PropTypes.object,
}

const ColorValueContainer = ({children, hasValue, selectProps, ...props}) => {
	const lastSelection = last(selectProps.value)
	const isOpenMenu = selectProps.menuIsOpen
	const colorValue = get(lastSelection, 'label', '')
	const showSuggestion = hasValue && isOpenMenu

	return reactSelectComponents.ValueContainer && (
		<reactSelectComponents.ValueContainer {...props} className={styles.colorValueContainer}>
			{showSuggestion && <span className="remove-one">{`Press Backspace to remove ${colorValue}`}</span>}
			<div className={cn({'selected-values': hasValue}, {'selected-values--with-suggestion': showSuggestion})}>
				{children}
			</div>
		</reactSelectComponents.ValueContainer>
	)
}

export const ColorSelectWrapper = (props) => (
	<ReactSelect
		isClearable={false}
		isSearchable={false}
		placeholder=""
		noOptionsMessage={noOptionsMessage}
		components={{Option: ColorOption, MultiValue: ColorValue, ValueContainer: ColorValueContainer}}
		isMulti
		joinValues
		hideSelectedOptions
		classNamePrefix="select"
		className={styles.colorSelect}
		{...props}
	/>
)

export const SelectTodoColorWrapper = ({value, options, ...props}) => {
	let selectedValue = value
	if (typeof selectedValue === 'string') {
        // This code enables the select to work with the new react-select
		selectedValue = options.find(option => option.value === selectedValue)
	}

	return (
		<ReactSelect
			value={selectedValue}
			options={options}
			isClearable={false}
			isSearchable={false}
			placeholder=""
			noOptionsMessage={noOptionsMessage}
			components={{Option: ColorOption, SingleValue: ColorValue}}
			classNamePrefix="select"
			className={cn(styles.colorSelect, 'todo-color-select')}
			{...props}
		/>
	)
}
SelectTodoColorWrapper.propTypes = {
	value: PropTypes.string,
	options: PropTypes.array,
}



// WEBPACK FOOTER //
// ./components/shared/select/ColorSelectWrapper.jsx